import type { StatCardProps } from "@/components/molecules/StatCard";
import { Alarm } from "iconsax-react";


export interface ModerationType {
    id: string;
    contentType: string;
    preview: string;
    reportedBy: string;
    dateReported: string;
    status: "Pending" | "Escalated";
    reason: string;
    reportCount: number;
}



export const MODERATION_STATS: StatCardProps[] = [
      {
        title: "Total Reports",
        value: "1,245",
        icon: <Alarm variant="Bold" color="#484848" className="w-6 h-6" />,
      },
      {
        title: "Pending Reviews",
        value: "20",
        icon: <Alarm variant="Bold" color="#484848" className="w-6 h-6" />,
      },
      {
        title: "Resolved",
        value: "50",
        icon: <Alarm variant="Bold" color="#484848" className="w-6 h-6" />,
      },
      {
        title: "Escalated to Legal",
        value: "20",
        icon: <Alarm variant="Bold" color="#484848" className="w-6 h-6" />,
      },
]


export const MOCK_MODERATION: ModerationType[] = [
    {
        id: "1",
        contentType: "Profile Bio",
        preview: "“Looking for fun only 😉…”",
        reportedBy: "@johnny",
        reason: "Inappropriate",
        reportCount: 8,
        dateReported: "2 Mar 2025",
        status: "Pending",
    },
    {
        id: "2",
        contentType: "Group Desc.",
        preview: "“Movie Night 🍻 – Free drinks…”",
        reportedBy: "@sarah_p",
        reason: "Misleading",
        reportCount: 8,
        dateReported: "2 Mar 2025",
        status: "Pending",
    },
    {
        id: "3",
        contentType: "Message",
        preview: "“Send me your bank details…”",
        reportedBy: "@davidk",
        reason: "Scam",
        reportCount: 8,
        dateReported: "2 Mar 2025",
        status: "Escalated",
    },
    {
        id: "4",
        contentType: "Profile Bio",
        preview: "“Looking for fun only 😉…”",
        reportedBy: "@johnny",
        reason: "Inappropriate",
        reportCount: 8,
        dateReported: "2 Mar 2025",
        status: "Escalated",
    },
]

export const REPORT_TABLE_HEADERS = [
  "Content Type",
  "Preview",
  "Reported By",
  "Reason",
  "Report Count",
  "Date Reported",
  "Status",
];
